import styled from 'styled-components';
import { StyledRteTheme } from './StyledRteTheme';

export const StyledMenuBarWrapper = styled.div`
  padding: 8px 8px;

  border: 1px solid
    ${props => props.theme.colorBorder ?? StyledRteTheme.colorBorder};
  border-bottom: none;

  // In Antd il border-radius varia in funzione della grandezza degli input
  border-radius: ${props =>
      props.theme.borderRadius ?? StyledRteTheme.borderRadius}px
    ${props => props.theme.borderRadius ?? StyledRteTheme.borderRadius}px 0 0;
  &.rte-menu-wrapper-lg {
    border-radius: ${props =>
        props.theme.borderRadiusLG ?? StyledRteTheme.borderRadiusLG}px
      ${props => props.theme.borderRadiusLG ?? StyledRteTheme.borderRadiusLG}px
      0 0;
  }
  &.rte-menu-wrapper-sm {
    border-radius: ${props =>
        props.theme.borderRadiusSM ?? StyledRteTheme.borderRadiusSM}px
      ${props => props.theme.borderRadiusSM ?? StyledRteTheme.borderRadiusSM}px
      0 0;
  }

  .ant-form-item-has-error & {
    border-color: ${props =>
      props.theme.colorError ?? StyledRteTheme.colorError};
  }
`;
